import(/* webpackMode: "eager" */ "/home/runner/work/play/play/src/app/(root)/referral/page.tsx");
